var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HandleHttpResponse, HttpStatusCode } from '@/data/protocols/http';
export class RemoteGetSupportLink {
    constructor(url, httpClient) {
        this.url = url;
        this.httpClient = httpClient;
    }
    getLink() {
        return __awaiter(this, void 0, void 0, function* () {
            let model = makeModel("", true);
            try {
                const httpResponse = yield this.httpClient.request({
                    url: this.url,
                    method: 'GET',
                });
                if ((httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.statusCode) && (httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.statusCode) === HttpStatusCode.ok && (httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.body)) {
                    model = makeModel(httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.body, false);
                }
            }
            catch (e) {
                console.log('OOPS', e);
            }
            return model;
        });
    }
    requestSupport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url: supportUrl, jwt, return_to } = params;
            const httpResponse = yield this.httpClient.unauthenticatedRequest({
                url: supportUrl,
                method: 'POST',
                body: { jwt, return_to },
                headers: {
                    "Host": "app.dev.nonp.kivera.io",
                    "Origin": "https://app.dev.nonp.kivera.io",
                    "Content-type": "application/json; charset=UTF-8",
                }
            });
            return HandleHttpResponse(httpResponse);
        });
    }
}
function makeModel(body, error) {
    return {
        error: error,
        data: body !== null && body !== void 0 ? body : ""
    };
}
